{
  "UnifiedNavigation": "在 Experience Cloud 中导航",
  "adobeExperienceCloudNoOrgsSelect": "选择其他组织帐户",
  "help": "帮助",
  "ok": "确定",
  "profile": "个人资料",
  "searchButton": "搜索",
  "sidenavMenuCloseTooltip": "关闭菜单",
  "sidenavMenuLockTooltip": "单击以锁定菜单",
  "solutionSwitcher": "切换至其他解决方案",
  "themeCoachMark": "浅色主题",
  "themeCoachMarkMessage": "Experience Cloud 标题现在支持浅色和深色主题。请单击您的头像以切换您的首选主题。",
  "toggleSideNav": "切换侧面导航菜单"
}
